import {
    ColumnDefinitionsDictionary,
    ValueType,
} from '@instinet-analytics/semantic-ui-components';

export type ExpertiseColumn =
    | 'dateTime'
    | 'orderId'
    | 'venueName'
    | 'size'
    | 'price'
    | 'symbol'
    | 'side'
    | 'eventType'
    | 'eventReason'
    | 'orderLevel'
    | 'ordType'
    | 'pegType'
    | 'tIF'
    | 'minFill'
    | 'tactic'
    | 'currency'
    | 'residual'
    | 'startTime'
    | 'endTime'
    | 'style'
    | 'maxPartRate'
    | 'fadeLogic'
    | 'footprintMinimization'
    | 'walkupProtection'
    | 'lastTradePrice'
    | 'bidPrice'
    | 'askPrice'
    | 'otherSymbol'
    | 'otherBidPrice'
    | 'otherAskPrice'
    | 'fxRate'
    | 'aggressionLevel'
    | 'algoType'
    | 'askPlus1Price'
    | 'askPlus1Size'
    | 'askSize'
    | 'bidMinus1Price'
    | 'bidMinus1Size'
    | 'bidSize'
    | 'bindingPriceRuleOrReason'
    | 'brokerName'
    | 'brokerRealTimeFairValue'
    | 'childDisplayedQty'
    | 'childMinAcceptQty'
    | 'childOrderId'
    | 'childOrderPriceLimit'
    | 'childOrderTIF'
    | 'childOrderType'
    | 'darkPoolPosting'
    | 'date'
    | 'dFARealTimeFairValue'
    | 'exchCounterCode'
    | 'executionPrice'
    | 'executionSize'
    | 'indexPctChange'
    | 'indexReferencePrice'
    | 'indexRelOffset'
    | 'indexRelReference'
    | 'indexValue'
    | 'iNetMaxRollingPart'
    | 'iNetMTVProbability'
    | 'iNetRollingPartWindow'
    | 'iNetRollingVolumeType'
    | 'iNetUseHistoricalVolume'
    | 'iRELRollingWindowMin'
    | 'lastTradeSize'
    | 'lastTradeTime'
    | 'maxExposurePerVenue'
    | 'maxPctVolume'
    | 'parentOrderState'
    | 'parentPrimaryPriceLimit'
    | 'predictedRemainMktVol'
    | 'reloadAndRefreshDelay'
    | 'reloadTriggerSeconds'
    | 'secondaryPriceLimit'
    | 'seq'
    | 'smallResidualMin'
    | 'smallTradeMinimization'
    | 'stockIRLimit'
    | 'stockPrimaryBBGCode'
    | 'stockReferencePrice'
    | 'tradeInClose'
    | 'tradeInOpen'
    | 'venueType'
    | 'venueVolInLimit'
    | 'vWAPVolumeAll'
    | 'way';

export const expertiseColumnDefinitions: ColumnDefinitionsDictionary<ExpertiseColumn> =
    {
        dateTime: {
            field: 'DateTime',
            name: 'Time',
            width: 160,
            valueType: ValueType.TIME,
        },
        orderId: {
            field: 'OrderId',
            name: 'Broker Parent Order ID',
            textAlign: 'left',
            width: 200,
            valueType: ValueType.STRING,
        },
        venueName: {
            field: 'VenueName',
            name: 'Venue Name',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        size: {
            field: 'Size',
            name: 'Unexecuted Order Size',
            width: 50,
            valueType: ValueType.NUMBER,
            precision: 0,
        },
        price: {
            field: 'Price',
            name: 'Order Price Limit',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        symbol: {
            field: 'Symbol',
            name: 'Symbol',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        side: {
            field: 'Side',
            name: 'Side',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        eventType: {
            field: 'EventType',
            name: 'Event Type',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        eventReason: {
            field: 'EventReason',
            name: 'Event Reason',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        orderLevel: {
            field: 'OrderLevel',
            name: 'Order Level',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        ordType: {
            field: 'OrdType',
            name: 'Order Type',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        pegType: {
            field: 'PegType',
            name: 'Peg Type',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        tIF: {
            field: 'TIF',
            name: 'Time In Force',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        minFill: {
            field: 'MinFill',
            name: 'MinFill',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        tactic: {
            field: 'Tactic',
            name: 'Tactic Generating Order',
            textAlign: 'left',
            width: 150,
            valueType: ValueType.STRING,
        },
        currency: {
            field: 'Currency',
            name: 'Currency',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        residual: {
            field: 'Residual',
            name: 'Parent Order Residual Size',
            width: 80,
            valueType: ValueType.NUMBER,
        },
        startTime: {
            field: 'startTime',
            name: 'Start Time',
            textAlign: 'left',
            width: 70,
            valueType: ValueType.TIME,
        },
        endTime: {
            field: 'endTime',
            name: 'End Time',
            textAlign: 'left',
            width: 70,
            valueType: ValueType.TIME,
        },
        style: {
            field: 'Style',
            name: 'Style',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        maxPartRate: {
            field: 'MaxPartRate',
            name: 'Maximum Part Rate',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        fadeLogic: {
            field: 'FadeLogic',
            name: 'Fade Logic',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        footprintMinimization: {
            field: 'FootprintMinimization',
            name: 'Footprint Minimization',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        walkupProtection: {
            field: 'WalkupProtection',
            name: 'Walkup Protection',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        lastTradePrice: {
            field: 'LastTradePrice',
            name: 'Last Trade Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        bidPrice: {
            field: 'BidPrice',
            name: 'Bid Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        askPrice: {
            field: 'AskPrice',
            name: 'Ask Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        otherSymbol: {
            field: 'OtherSymbol',
            name: 'Other Symbol',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        otherBidPrice: {
            field: 'OtherBidPrice',
            name: 'Other Bid Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        otherAskPrice: {
            field: 'OtherAskPrice',
            name: 'Other Ask Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        fxRate: {
            field: 'FxRate',
            name: 'Fx Rate',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        aggressionLevel: {
            field: 'AggressionLevel',
            name: 'Aggression Level',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        algoType: {
            field: 'AlgoType',
            name: 'Algo Type',
            textAlign: 'left',
            width: 100,
            valueType: ValueType.STRING,
        },
        askPlus1Price: {
            field: 'AskPlus1Price',
            name: 'Ask1Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        askPlus1Size: {
            field: 'AskPlus1Size',
            name: 'Ask1Size',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        askSize: {
            field: 'AskSize',
            name: 'Ask Size',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        bidMinus1Price: {
            field: 'BidMinus1Price',
            name: 'Bid1Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        bidMinus1Size: {
            field: 'BidMinus1Size',
            name: 'Bid1Size',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        bidSize: {
            field: 'BidSize',
            name: 'Bid Size',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        bindingPriceRuleOrReason: {
            field: 'BindingPriceRuleOrReason',
            name: 'Binding Price Rule Or Reason',
            textAlign: 'left',
            width: 100,
            valueType: ValueType.STRING,
        },
        brokerName: {
            field: 'BrokerName',
            name: 'Broker Name',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        brokerRealTimeFairValue: {
            field: 'BrokerRealTimeFairValue',
            name: "Broker's Model Real Time Fair Value for Security",
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        childDisplayedQty: {
            field: 'ChildDisplayedQty',
            name: 'Child Displayed Qty',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        childMinAcceptQty: {
            field: 'ChildMinAcceptQty',
            name: 'Child Min Accept Qty',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        childOrderId: {
            field: 'ChildOrderId',
            name: 'Broker Child Order ID',
            textAlign: 'left',
            width: 200,
            valueType: ValueType.NUMBER,
            textualQuickSearch: true,
            raw: true,
        },
        childOrderPriceLimit: {
            field: 'ChildOrderPriceLimit',
            name: 'Child Price Limit',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        childOrderTIF: {
            field: 'ChildOrderTIF',
            name: 'Child TIF',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        childOrderType: {
            field: 'ChildOrderType',
            name: 'Child Type',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        darkPoolPosting: {
            field: 'DarkPoolPosting',
            name: 'Dark Pool Posting',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        date: {
            field: 'date',
            name: 'Local Market Trade Date',
            textAlign: 'left',
            width: 70,
            valueType: ValueType.DATE,
        },
        dFARealTimeFairValue: {
            field: 'DFARealTimeFairValue',
            name: "DFA's Model Real Time Fair Value for Security (Used in Sweep & Mid)",
            textAlign: 'left',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },

        exchCounterCode: {
            field: 'ExchCounterCode',
            name: 'Exchange Counterparty Code',
            width: 100,
            valueType: ValueType.NUMBER,
        },
        executionPrice: {
            field: 'ExecutionPrice',
            name: 'Exec Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        executionSize: {
            field: 'ExecutionSize',
            name: 'Execution Size',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        indexPctChange: {
            field: 'IndexPctChange',
            name: 'Index % Change since Ref Price Snap Shot',
            width: 70,
            precision: 2,
            valueType: ValueType.NUMBER,
        },
        indexReferencePrice: {
            field: 'IndexReferencePrice',
            name: 'Index Reference Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        indexRelOffset: {
            field: 'IndexRelOffset',
            name: 'Index Ref Offset',
            width: 70,
            valueType: ValueType.NUMBER,
        },
        indexRelReference: {
            field: 'IndexRelReference',
            name: 'Index Rel Reference',
            textAlign: 'left',
            width: 100,
            valueType: ValueType.STRING,
        },
        indexValue: {
            field: 'IndexValue',
            name: 'Live Index Value',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        iNetMaxRollingPart: {
            field: 'INET_MaxRollingPart',
            name: 'Max Rolling Part',
            width: 70,
            precision: 2,
            valueType: ValueType.NUMBER,
        },
        iNetMTVProbability: {
            field: 'INET_MTVProbability',
            name: 'MTV Probability',
            width: 70,
            valueType: ValueType.STRING,
        },
        iNetRollingPartWindow: {
            field: 'INET_RollingPartWindow',
            name: 'Rolling Part Window',
            width: 70,
            precision: 2,
            valueType: ValueType.NUMBER,
        },
        iNetRollingVolumeType: {
            field: 'INET_RollingVolumeType',
            name: 'Rolling Vol Type',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        iNetUseHistoricalVolume: {
            field: 'INET_UseHistoricalVolume',
            name: 'Use Historical Volume',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        iRELRollingWindowMin: {
            field: 'IRELRollingWindowMin',
            name: 'IREL Rolling Window',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        lastTradeSize: {
            field: 'LastTradeSize',
            name: 'Last Trade Size',
            width: 50,
            valueType: ValueType.STRING,
        },
        lastTradeTime: {
            field: 'lastTradeTime',
            name: 'Last Trade Time',
            textAlign: 'left',
            width: 70,
            valueType: ValueType.TIME,
        },
        maxExposurePerVenue: {
            field: 'MaxExposurePerVenue',
            name: 'Max Exposure Per Venue',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        maxPctVolume: {
            field: 'MaxPctVolume',
            name: 'Max % Of Volume',
            width: 70,
            precision: 2,
            valueType: ValueType.NUMBER,
        },
        parentOrderState: {
            field: 'ParentOrderState',
            name: 'Parent Order State',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        parentPrimaryPriceLimit: {
            field: 'ParentPrimaryPriceLimit',
            name: 'Parent Order Primary Price Limit',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        predictedRemainMktVol: {
            field: 'PredictedRemainMktVol',
            name: 'Predicted Rem Vol',
            width: 80,
            valueType: ValueType.NUMBER,
        },
        reloadAndRefreshDelay: {
            field: 'ReloadAndRefreshDelay',
            name: 'Reload & Refresh Delay',
            width: 50,
            valueType: ValueType.NUMBER,
        },
        reloadTriggerSeconds: {
            field: 'ReloadTriggerSeconds',
            name: 'Reload Trigger Sec',
            width: 50,
            valueType: ValueType.NUMBER,
        },

        secondaryPriceLimit: {
            field: 'SecondaryPriceLimit',
            name: 'SecondaryPriceLimit',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        seq: { field: 'seq', name: 'Sequence', valueType: ValueType.NUMBER },
        smallResidualMin: {
            field: 'SmallResidualMin',
            name: 'Small Residual Min',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        smallTradeMinimization: {
            field: 'SmallTradeMinimization',
            name: 'Small Trade Minimization',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        stockIRLimit: {
            field: 'StockIRLimit',
            name: 'Stock IR Limit',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        stockPrimaryBBGCode: {
            field: 'StockPrimaryBBGCode',
            name: 'Stock Primary BBG Code',
            textAlign: 'left',
            width: 70,
            valueType: ValueType.STRING,
        },
        stockReferencePrice: {
            field: 'StockReferencePrice',
            name: 'Stock Reference Price',
            width: 70,
            valueType: ValueType.NUMBER,
            precision: 4,
        },
        tradeInClose: {
            field: 'TradeInClose',
            name: 'Trade In Close',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        tradeInOpen: {
            field: 'TradeInOpen',
            name: 'Trade In Open',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        venueType: {
            field: 'VenueType',
            name: 'Venue Type',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
        venueVolInLimit: {
            field: 'VenueVolInLimit',
            name: 'Venue Vol In Limit',
            width: 80,
            valueType: ValueType.NUMBER,
        },
        vWAPVolumeAll: {
            field: 'VWAPVolumeAll',
            name: 'Market VWAP Volume (All)',
            width: 80,
            valueType: ValueType.NUMBER,
        },
        way: {
            field: 'Way',
            name: 'Way',
            textAlign: 'left',
            width: 50,
            valueType: ValueType.STRING,
        },
    };
